
/**
 * Makes an AJAX request adding a school-level giving donation for ${amount} earmarked for school ${schoolId} to your
 * cart.
 */
export const giveToSchool = (schoolId, amount, onSuccess, onFail) => {
    $.ajax({
        url: secureBaseURL + 'donors/cart/school-donation.json',
        method: "POST",

        data: {
            'schoolId': schoolId,
            'value': amount,
        },
        dataType: 'json',
        xhrFields: {
            // Most callers will hit this URL from WWW
            withCredentials: true
        },
    }).done((data) => {
        onSuccess(data);
    }).fail((data) => {
        onFail(data);
    });
}
